
import { useState } from 'react';

export default function Products() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const products = [
    {
      id: 1,
      title: 'Secure VPN',
      description: 'Private browsing and data protection',
      details: 'Military-grade encryption, global server network, no-logs policy, lightning-fast connection speeds',
      gradient: 'from-purple-600 via-blue-600 to-blue-500',
      icon: 'ri-shield-check-line'
    },
    {
      id: 2,
      title: 'Device Cleaner',
      description: 'Optimize storage and performance',
      details: 'Smart cleanup algorithms, duplicate file detection, memory optimization, battery life enhancement',
      gradient: 'from-emerald-500 via-teal-500 to-cyan-500',
      icon: 'ri-brush-line'
    }
  ];

  return (
    <section id="products" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-4">
            Our Applications <span className="text-5xl">📱</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Powerful iOS applications designed to protect and optimize your mobile experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="relative group cursor-pointer"
              onMouseEnter={() => setHoveredCard(product.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className={`relative h-[500px] rounded-2xl overflow-hidden transition-all duration-500 ${hoveredCard === product.id ? 'scale-105' : 'scale-100'}`}>
                {/* Gradient Background */}
                <div className={`absolute inset-0 bg-gradient-to-br ${product.gradient}`}></div>
                
                {/* Icon */}
                <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <div className="w-32 h-32 flex items-center justify-center">
                    <i className={`${product.icon} text-8xl text-white/30`}></i>
                  </div>
                </div>

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-3xl font-bold text-white mb-2">{product.title}</h3>
                  <p className="text-base text-white/90 mb-4">{product.description}</p>
                  
                  {/* Expanded Details */}
                  <div className={`transition-all duration-500 overflow-hidden ${hoveredCard === product.id ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <p className="text-sm text-white/80 leading-relaxed">{product.details}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
